/* eslint-disable import/no-duplicates */
import { format, isToday, isYesterday, parse } from "date-fns"
// import { zonedTimeToUtc } from "date-fns-tz"
import { enUS, ru } from "date-fns/locale"
import i18next from "i18next"

export { isToday, isYesterday }

export const parseDateTime = (date: Date | string): Date => {
  return parse((date as unknown) as string, "yyyy-MM-dd HH:mm:ss", new Date())
}

export const parseDate = (date: Date | string): Date => {
  return parse((date as unknown) as string, "yyyy-MM-dd", new Date())
}

export const isOnlyDate = (date: Date | string): boolean => {
  return date.toString().split(" ").length === 1
}

export const formatDate = (date: Date | string, options?: Intl.DateTimeFormatOptions): string => {
  if (!date) {
    return ""
  }

  const locales: Record<string, string> = {
    en: "en-Us",
    ru: "ru-Ru",
  }

  const formatOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }

  return new Date(date).toLocaleString(locales[i18next.language], {
    ...formatOptions,
    ...options,
  })
}

type FormatProps = {
  date: Date | string
  formatVariant: "d MMMM yyyy" | "dd.MM.yyyy" | "dd.MM.yy" | "d MMMM, HH:mm"
}

const locale: Record<string, any> = {
  en: enUS,
  ru: ru,
}

export const formatDateNew = (
  date: FormatProps["date"],
  formatVariant: FormatProps["formatVariant"],
): string => {
  if (!date) {
    return ""
  }

  date = isOnlyDate(date) ? parseDate(date) : parseDateTime(date)

  return format(new Date(date), formatVariant, { locale: locale[i18next.language] })
}

// console.log("parseDate: ", parseDate("2020-06-10"))
// console.log("parseDateTime: ", parseDateTime("2020-06-10 12:00:00"))
// console.log("Date:", formatDateNew("2020-06-10", "d MMMM yyyy"))
// console.log("Time:", formatDateNew("2020-06-10 12:00:00", "d MMMM, HH:mm"))

// console.log(formatDate(parse("2020-06-10", "yyyy-MM-dd", new Date())))
// console.log(zonedTimeToUtc(parse("2020-06-10", "yyyy-MM-dd", new Date()), "Europe/Moscow"))
